import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	accountSettings: {
		defaultMessage: 'Atlassian account settings',
		id: 'atlassian-navigation.settings.menu.personal.account-settings',
		description: 'Account settings message',
	},
	accountSettingsDescription: {
		defaultMessage: 'Manage your language, time zone, and other profile information.',
		id: 'atlassian-navigation.settings.menu.personal.account-settings-description',
		description: 'Atlassian account settings descriptions',
	},
	personalJiraSettings: {
		defaultMessage: 'Personal Jira settings',
		id: 'atlassian-navigation.settings.menu.personal.personal-jira-settings',
		description: 'Personal Jira settings',
	},
	personalJiraSettingsDescription: {
		defaultMessage: 'Manage your email notifications and other Jira settings.',
		id: 'atlassian-navigation.settings.menu.personal.personal-jira-settings-description',
		description: 'Personal Jira settings descriptions',
	},
	commandPaletteSearchButtonLabelMac: {
		defaultMessage: 'Search ( <wrapper><command>⌘</command> + <key>K</key></wrapper> )',
		id: 'atlassian-navigation.settings.menu.personal.command-palette-search-button-label-mac',
		description: 'Label for command palette search button in settings menu',
	},
	commandPaletteSearchButtonLabelOther: {
		defaultMessage: 'Search ( <wrapper><command>Ctrl</command> + <key>K</key></wrapper> )',
		id: 'atlassian-navigation.settings.menu.personal.command-palette-search-button-label-other',
		description: 'Label for command palette search button in settings menu',
	},
	// Nav4 Messages
	generalSettingsLabel: {
		defaultMessage: 'General settings',
		id: 'atlassian-navigation.settings.menu.personal.general-settings-label',
		description: 'Label for general settings dropdown item',
	},
	generalSettingsDescription: {
		defaultMessage: 'Manage language, time zone, and other personal preferences',
		id: 'atlassian-navigation.settings.menu.personal.general-settings-description',
		description: 'Description for general settings dropdown item',
	},
	notificationSettingsLabel: {
		defaultMessage: 'Notification settings',
		id: 'atlassian-navigation.settings.menu.personal.notification-settings-label',
		description: 'Label for notification settings dropdown item',
	},
	notificationSettingsDescription: {
		defaultMessage: 'Manage email and in-product notifications from Jira',
		id: 'atlassian-navigation.settings.menu.personal.notification-settings-description',
		description: 'Description for notification settings dropdown item',
	},
});
